import { FC, useCallback, useContext } from 'react';

import { RedeliveryContext } from '../redelivery-context';

const RedeliveryDetailAddButton: FC = () => {
  const { redeliveryDetails, setRedeliveryDetails } = useContext(RedeliveryContext);

  const addRedeliveryDetail = useCallback(() => {
    const id = -new Date().valueOf();
    if (redeliveryDetails.has(id)) return;
    setRedeliveryDetails(prevState => new Map(prevState).set(id, { count: 0, id, sizeType: '' }));
  }, [redeliveryDetails, setRedeliveryDetails]);

  return (
    <button
      className="btn-outline col-start-1"
      data-cy="redelivery-add-equipment-button"
      onClick={addRedeliveryDetail}
      type="button"
    >
      ADD EQUIPMENT
    </button>
  );
};

export default RedeliveryDetailAddButton;
